import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Register from './pages/Register';
import AuthCallback from './pages/AuthCallback';
import Onboarding from './pages/Onboarding';
import Dashboard from './pages/Dashboard';
import Jobs from './pages/Jobs';
import Queue from './pages/Queue';
import Inventory from './pages/Inventory';
import Locations from './pages/Locations';
import AuditLog from './pages/AuditLog';
import Organization from './pages/settings/Organization';
import Team from './pages/settings/Team';
import Kiosk from './pages/settings/Kiosk';
import Billing from './pages/settings/Billing';
import DangerZone from './pages/settings/DangerZone';
import Departments from './pages/Departments';
import FloorAudit from './pages/FloorAudit';
import KioskView from './pages/KioskView';

const NotFound = () => (
  <div style={{
    minHeight:'100vh',background:'#08080a',display:'flex',flexDirection:'column',
    alignItems:'center',justifyContent:'center',color:'#f0f0f2',
    fontFamily:'Inter,sans-serif',gap:'10px'
  }}>
    <div style={{fontSize:'40px',fontWeight:700,letterSpacing:'2px'}}>404</div>
    <div style={{color:'#8b96a5',fontSize:'14px'}}>That page doesn't exist.</div>
    <a href="/dashboard" style={{color:'#3b82f6',fontSize:'14px',marginTop:'8px'}}>Back to dashboard</a>
  </div>
);

const ProtectedRoute = ({ children }) => {
  const { user, org, loading } = useAuth();
  if (loading) return <div style={{color:'white',minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center'}}>Loading...</div>;
  if (!user) return <Navigate to="/" />;
  if (org && !org.onboarded) return <Navigate to="/onboarding" />;
  return children;
};

const OnboardingRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div style={{color:'white',minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center'}}>Loading...</div>;
  if (!user) return <Navigate to="/" />;
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/auth-callback" element={<AuthCallback />} />
        {/* Public floor-facing kiosk -- PIN login, no admin auth */}
        <Route path="/kiosk/:slug" element={<KioskView />} />
        <Route path="/onboarding" element={<OnboardingRoute><Onboarding /></OnboardingRoute>} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/queue" element={<ProtectedRoute><Queue /></ProtectedRoute>} />
        <Route path="/jobs" element={<ProtectedRoute><Jobs /></ProtectedRoute>} />
        <Route path="/inventory" element={<ProtectedRoute><Inventory /></ProtectedRoute>} />
        <Route path="/locations" element={<ProtectedRoute><Locations /></ProtectedRoute>} />
        <Route path="/audit" element={<ProtectedRoute><AuditLog /></ProtectedRoute>} />
        <Route path="/departments" element={<ProtectedRoute><Departments /></ProtectedRoute>} />
        <Route path="/settings/organization" element={<ProtectedRoute><Organization /></ProtectedRoute>} />
        <Route path="/settings/team" element={<ProtectedRoute><Team /></ProtectedRoute>} />
        <Route path="/settings/kiosk" element={<ProtectedRoute><Kiosk /></ProtectedRoute>} />
        <Route path="/settings/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
        <Route path="/settings/danger" element={<ProtectedRoute><DangerZone /></ProtectedRoute>} />
        <Route path="/floor-audit" element={<ProtectedRoute><FloorAudit /></ProtectedRoute>} />
        {/* Catch-all: unknown URLs land somewhere sane instead of a blank page */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;